import { useMutation } from "@tanstack/react-query";
import { useNotification } from "@refinedev/core";

import { ApiError } from "@shared/types";
import { Activity } from "@modules/activities/types";
import { ActivityFormValues } from "@modules/activities/validations";

import { createActivityService } from "./service";
import { UseCreateActivityMutationOptions } from "./types";

export function useCreateActivityMutation(
  options?: UseCreateActivityMutationOptions
) {
  const { open } = useNotification();

  return useMutation<Activity, ApiError, ActivityFormValues>({
    mutationFn: createActivityService,
    onError: (error: ApiError) => {
      open?.({
        type: "error",
        message: error.response.data.error,
      });
    },
    ...options,
  });
}
